const CardCertifications = (item, colorScheme) => {
  const { title, certification } = item

  return {
    title,
    certification,
    parentColorScheme: colorScheme
  }
}

export default CardCertifications